import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { PassengerType } from '../../../core/enums/passenger-type.enum';
import { PriceRateDescriptor } from '../../../core/enums/price-rate-descriptor.enum';
import { PriceRate } from '../../../core/models/price-rate';
import { HttpRequestService } from '../../../shared/services/http-request.service';
import { PriceRateService } from './price-rate.service';
import { CabinaItinerarioMenor } from '../../../core/models/cabin/cabina-itinerario-menor';

@Injectable({
  providedIn: 'root',
})
export class CabinService {
  auxCabins: CabinaItinerarioMenor[] = [];

  public static getPrice(): number {
    return 0;
  }

  constructor(
    private httpRequestServic: HttpRequestService,
    @Inject(PriceRateService) private priceRateService: PriceRateService
  ) {}

  public getCabins(searchRequestObject: any) {
    try {
      return this.httpRequestServic.requestPost(
        'findCabins',
        searchRequestObject
      );
    } catch (error) {
      console.error(error);

      return this.handleError(error);
    }
  }
  private handleError(error: any): Observable<any> {
    console.error('Error in Cabin Service');
    console.error(error);
    return throwError(new Error(error));
  }

  public getAirFarePriceRate(passengerType: PassengerType): number {
    let airFarePriceRate: PriceRateDescriptor;
    if (passengerType === PassengerType.CHILD) {
      airFarePriceRate = PriceRateDescriptor.ChildrenAirFare;
    } else {
      airFarePriceRate = PriceRateDescriptor.AirFare;
    }

    const priceRateAirFare: PriceRate | undefined =
      this.priceRateService.getPriceRateByName(airFarePriceRate);
    return !priceRateAirFare ? 0 : priceRateAirFare.valor;
  }
  public getAppPrice(
    price: number,
    cruiseCategory: number,
    promoCode: number,
    includeAirFare: boolean,
    passengerType: PassengerType,
    agencyPercent?: number
  ): number {
 
      return this.getPriceToPublic(
        price,
        includeAirFare,
        passengerType,
        (agencyPercent ? agencyPercent : 0) / 100
      );
  
    /*
     try {
    let priceRate: PriceRate;
    let airFare = 0;
    const cruisePricePromo: number = price;

    if (includeAirFare) {
      let airFarePriceRate: PriceRateDescriptor;
      if (passengerType === PassengerType.CHILD) {
        airFarePriceRate = PriceRateDescriptor.ChildrenAirFare;
      } else {
        airFarePriceRate = PriceRateDescriptor.AirFare;
      }

      const priceRateAirFare: PriceRate = this.priceRateService.getPriceRateByName(airFarePriceRate);
      airFare = isNullOrUndefined(priceRateAirFare) ? 0 : priceRateAirFare.valor;
    }

    if (cruiseCategory === 5 || cruiseCategory === 4) {
      if (cruiseCategory === 5) {
        if (includeAirFare) {
          if (promoCode === PromoCode.PROMO_RAC || promoCode === PromoCode.PROMO_OFF || promoCode === PromoCode.PROMO_PORCENT_OFF) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.AirFare_C5_RACK_XOFF);
          } else if (promoCode === PromoCode.PROMO_2_X_1) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.AirFare_C5_2X1);
          } else if (promoCode === PromoCode.PROMO_NET) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.AirFare_C5_NET);
          }
        } else {
          if (promoCode === PromoCode.PROMO_RAC || promoCode === PromoCode.PROMO_OFF || promoCode === PromoCode.PROMO_PORCENT_OFF) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.C5_RACK_XOFF);
          } else if (promoCode === PromoCode.PROMO_2_X_1) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.C5_2X1);
          } else if (promoCode === PromoCode.PROMO_NET) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.C5_NET);
          }
        }
      } else {
        if (includeAirFare) {
          if (promoCode === PromoCode.PROMO_RAC || promoCode === PromoCode.PROMO_OFF || promoCode === PromoCode.PROMO_PORCENT_OFF) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.AirFare_C4_RACK_XOFF);
          } else if (promoCode === PromoCode.PROMO_2_X_1) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.AirFare_C4_2X1);
          } else if (promoCode === PromoCode.PROMO_NET) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.AirFare_C4_NET);
          }
        } else {
          if (promoCode === PromoCode.PROMO_RAC || promoCode === PromoCode.PROMO_OFF || promoCode === PromoCode.PROMO_PORCENT_OFF) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.C4_RACK_XOFF);
          } else if (promoCode === PromoCode.PROMO_2_X_1) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.C4_2X1);
          } else if (promoCode === PromoCode.PROMO_NET) {
            priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.C4_NET);
          }
        }

      }
    } else if (cruiseCategory === 3 || cruiseCategory === 2) {

      if (includeAirFare) {
        if (promoCode === PromoCode.PROMO_RAC || promoCode === PromoCode.PROMO_OFF || promoCode === PromoCode.PROMO_PORCENT_OFF) {
          priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.AirFare_C3C2_RACK_XOFF);
        } else if (promoCode === PromoCode.PROMO_2_X_1) {
          priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.AirFare_C3C2_2X1);
        } else if (promoCode === PromoCode.PROMO_NET) {
          priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.AirFare_C3C2_NET);
        }
      } else {
        if (promoCode === PromoCode.PROMO_RAC || promoCode === PromoCode.PROMO_OFF || promoCode === PromoCode.PROMO_PORCENT_OFF) {
          priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.C3C2_RACK_XOFF);
        } else if (promoCode === PromoCode.PROMO_2_X_1) {
          priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.C3C2_2X1);
        } else if (promoCode === PromoCode.PROMO_NET) {
          priceRate = this.priceRateService.getPriceRateByName(PriceRateDescriptor.C3C2_NET);
        }
      }
    } else {
      priceRate = null;
    }
    // const priceRateValue = priceRate ? priceRate.valor : 1;y

    const priceRateValue = isNullOrUndefined(agencyPercent) || agencyPercent === 0 ? priceRate.valor : agencyPercent;
    return Math.floor((cruisePricePromo / priceRateValue) + airFare);
  } catch (error) {
    console.error('CabinaService.getAppPrice() > An error appeared while trying to calculate the price: ' + error);
    return null;
  }
*/
  }
  getPriceToPublic(
    price: number,
    includeAirFare: boolean,
    passengerType: PassengerType,
    agencyPercent?: number
  ) {
    let airFare = 0;
    const cruisePricePromo: number = price;

    if (includeAirFare) {
      let airFarePriceRate: PriceRateDescriptor;
      if (passengerType === PassengerType.CHILD) {
        airFarePriceRate = PriceRateDescriptor.ChildrenAirFare;
      } else {
        airFarePriceRate = PriceRateDescriptor.AirFare;
      }
      const priceRateAirFare: PriceRate | undefined =
        this.priceRateService.getPriceRateByName(airFarePriceRate);
      airFare = !priceRateAirFare ? 0 : priceRateAirFare.valor;
    }
    return Math.floor(
      cruisePricePromo -
        cruisePricePromo * (agencyPercent ? agencyPercent : 0) +
        airFare
    );
  }

  setCabins(value: CabinaItinerarioMenor[]) {
    this.auxCabins = value;
  }

  getCabinsFromServer(): CabinaItinerarioMenor[]{
    return this.auxCabins
  }
}
